import { Component, Input, Output, EventEmitter, OnChanges, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-alert-detalhe-fatura',
    templateUrl: './alert-detalhe-fatura.component.html',
    styleUrls: ['./alert-detalhe-fatura.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager
})

export class AlertDetalheFaturaComponent implements OnChanges {

  @Input() alertDetalheFatura: boolean = false;
  @Input() dadosFatura: any = null;
  @Output() alertFaturaFechou = new EventEmitter();

  constructor() { }

  ngOnChanges(changes: any) {
    if(this.dadosFatura) {

      // QUANDO TIVER OS DADOS ELE ESCREVE NO HTML
      document.querySelector('#content').innerHTML = this.dadosFatura;
    }
  }

  fecharModalFatura() { this.alertFaturaFechou.emit('Fechou'); }

  onPrint() {
    let WinPrint = window.open('', '', 'width=640,height=auto');
    WinPrint.document.body.innerHTML = this.dadosFatura;
    WinPrint.document.close();
    WinPrint.focus();
    WinPrint.print();
    WinPrint.close();
  }

}
